export const balanceAction = {
	addFunds: "ADD_FUNDS",
	withdraw: "WITHDRAW",
};
